/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type EscalationListPaginationContainer_search$ref = any;
export type SearchType = "ADMITS" | "ATTENTION" | "BARRIER" | "DISCHARGE" | "ESCALATIONS" | "LOS_REVIEW" | "PATIENT" | "PROGRESSION" | "VARIANCE" | "VISIT" | "%future added value";
export type EscalationListQueryVariables = {|
  first?: ?number,
  after?: ?string,
  getSettingsRoles: boolean,
  skipOwnerKnownUser: boolean,
  type?: ?SearchType,
  query?: ?string,
|};
export type EscalationListQueryResponse = {|
  +$fragmentRefs: EscalationListPaginationContainer_search$ref
|};
export type EscalationListQuery = {|
  variables: EscalationListQueryVariables,
  response: EscalationListQueryResponse,
|};
*/


/*
query EscalationListQuery(
  $first: Int
  $after: String
  $getSettingsRoles: Boolean!
  $skipOwnerKnownUser: Boolean!
  $type: SearchType
  $query: String
) {
  ...EscalationListPaginationContainer_search_27bWcs
}

fragment EscalationListPaginationContainer_search_27bWcs on Query {
  userSetting @include(if: $getSettingsRoles) {
    barriers {
      id
      name
      description
      active
      dischargeDelay
      category {
        code
        value
        id
      }
      templateId
    }
  }
  barrierEscalationRoles: codeTables(codeTableType: BarrierEscalationRole) @include(if: $getSettingsRoles) {
    code
    value
    ordinal
    active
    id
  }
  deliveryMethods: codeTables(codeTableType: DeliveryMethod) {
    code
    active
    id
  }
  viewer {
    beds(first: $first, after: $after, type: $type, query: $query) {
      totalCount
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
        totalCount
      }
      edges {
        bed: node {
          id
          name
          exchangeName
          status
          department {
            id
            exchangeName
            name
            type
          }
          visit {
            id
            vector {
              id
              patientId
              encounterId
              predictionDate
              conditions {
                name
                riskBracket
                riskFactors {
                  id
                  type
                  description
                }
                recommendations {
                  id
                  rank
                  description
                  code
                  accepted
                }
              }
            }
            admissionTime
            admissionType
            admittingComplaint
            anticipatedDischargeTime
            anticipatedDischargeUpdatedBy {
              id
              userName
              firstName
              lastName
            }
            attendingPhysician {
              firstName
              id
              lastName
            }
            bedRequestStatus
            bedRequests {
              id
              bedRequestType
              bedRequestStatus
              updatedWhen
              bedExchangeName
            }
            currentDayOfStay
            decisionTime
            dischargeVendor
            drgAttributes {
              id
              code
              level
              title
            }
            drgUpdatedBy {
              id
              firstName
              lastName
              userName
            }
            homeBedExchangeName
            insurancePlans {
              id
              planName
              priority
            }
            meta {
              id
              decisionDue
              dischargeToday
              plannedDischargeExceeded
              timeElapsedSinceAdmission
              tlosExceeded
            }
            patient {
              id
              age
              firstName
              gender
              lastName
              middleInitial
              mrn
            }
            patientProblem
            targetDischargeTime
            tlos
            visitNumber
            visitStatus
            workingDischargeDisposition {
              code
              id
              value
            }
            plan {
              id
              barriers {
                id
                name
                description
                dischargeDelay
                pinned
                status
                category {
                  id
                  code
                  value
                  sourceTypes {
                    id
                    code
                    value
                    active
                    activeDirectorySourceName
                    hasConfiguredList
                    sourceDetails {
                      id
                      code
                      value
                      active
                    }
                  }
                }
                escalation {
                  id
                  auditMeta {
                    createdBy {
                      id
                      userName
                      firstName
                      lastName
                    }
                    updatedBy {
                      id
                      userName
                      firstName
                      lastName
                    }
                    created
                    updated
                  }
                }
                auditMeta {
                  createdBy {
                    id
                    userName
                    firstName
                    lastName
                  }
                  updatedBy {
                    id
                    userName
                    firstName
                    lastName
                  }
                  created
                  updated
                }
                ownerMessageStatus
                ownerMessageStatusDate
                ownerMessageDeliveryDate
                ownerKnownUser @skip(if: $skipOwnerKnownUser) {
                  id
                  emailReceiver
                  instantMessageReceiver
                }
                owner
                ownerRole {
                  id
                  code
                  value
                }
                sourceTypeCode
                sourceName
                notes {
                  id
                  text
                  pinned
                  auditMeta {
                    createdBy {
                      id
                      userName
                      firstName
                      lastName
                    }
                    updatedBy {
                      id
                      userName
                      firstName
                      lastName
                    }
                    created
                    updated
                  }
                }
              }
              careTeamMembers {
                id
                name
                role {
                  id
                  code
                  value
                }
                primary
              }
              meta {
                milestoneMeta {
                  overdue
                  onTime
                  completed
                }
                lengthOfStayMeta {
                  forecast
                  cappedForecast
                }
                actualOE
              }
              milestones {
                id
                name
                description
                dueDate
                dueDateCutoff
                completedDate
                track
                status
                duplicate
              }
              progressionIndicator
              toBeAdmitted
            }
            anticipatedTransferTime
            anticipatedDischargeTimeAutoPopulated
            anticipatedTransferTimeAutoPopulated
          }
        }
        cursor
        node {
          __typename
          id
        }
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "getSettingsRoles"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "query"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipOwnerKnownUser"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "type"
},
v6 = {
  "kind": "Variable",
  "name": "after",
  "variableName": "after"
},
v7 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v8 = {
  "kind": "Variable",
  "name": "query",
  "variableName": "query"
},
v9 = {
  "kind": "Variable",
  "name": "type",
  "variableName": "type"
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "active",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v13 = [
  (v6/*: any*/),
  (v7/*: any*/),
  (v8/*: any*/),
  (v9/*: any*/)
],
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "exchangeName",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userName",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v23 = [
  (v12/*: any*/),
  (v20/*: any*/),
  (v21/*: any*/),
  (v22/*: any*/)
],
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "bedRequestStatus",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dischargeDelay",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pinned",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "concreteType": "AuditMeta",
  "kind": "LinkedField",
  "name": "auditMeta",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AuditUser",
      "kind": "LinkedField",
      "name": "createdBy",
      "plural": false,
      "selections": (v23/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AuditUser",
      "kind": "LinkedField",
      "name": "updatedBy",
      "plural": false,
      "selections": (v23/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "created",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updated",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v29 = [
  (v12/*: any*/),
  (v10/*: any*/),
  (v25/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "EscalationListQuery",
    "selections": [
      {
        "args": [
          (v6/*: any*/),
          (v7/*: any*/),
          {
            "kind": "Variable",
            "name": "getSettingsRoles",
            "variableName": "getSettingsRoles"
          },
          (v8/*: any*/),
          {
            "kind": "Variable",
            "name": "skipOwnerKnownUser",
            "variableName": "skipOwnerKnownUser"
          },
          (v9/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "EscalationListPaginationContainer_search"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "EscalationListQuery",
    "selections": [
      {
        "alias": "deliveryMethods",
        "args": [
          {
            "kind": "Literal",
            "name": "codeTableType",
            "value": "DeliveryMethod"
          }
        ],
        "concreteType": "CodeTable",
        "kind": "LinkedField",
        "name": "codeTables",
        "plural": true,
        "selections": [
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/)
        ],
        "storageKey": "codeTables(codeTableType:\"DeliveryMethod\")"
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v13/*: any*/),
            "concreteType": "BedConnection",
            "kind": "LinkedField",
            "name": "beds",
            "plural": false,
            "selections": [
              (v14/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endCursor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasNextPage",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasPreviousPage",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "startCursor",
                    "storageKey": null
                  },
                  (v14/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "BedEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": "bed",
                    "args": null,
                    "concreteType": "Bed",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v12/*: any*/),
                      (v15/*: any*/),
                      (v16/*: any*/),
                      (v17/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Department",
                        "kind": "LinkedField",
                        "name": "department",
                        "plural": false,
                        "selections": [
                          (v12/*: any*/),
                          (v16/*: any*/),
                          (v15/*: any*/),
                          (v18/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Visit",
                        "kind": "LinkedField",
                        "name": "visit",
                        "plural": false,
                        "selections": [
                          (v12/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PatientVector",
                            "kind": "LinkedField",
                            "name": "vector",
                            "plural": false,
                            "selections": [
                              (v12/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "patientId",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "encounterId",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "predictionDate",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "PatientCondition",
                                "kind": "LinkedField",
                                "name": "conditions",
                                "plural": true,
                                "selections": [
                                  (v15/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "riskBracket",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "PatientRiskFactor",
                                    "kind": "LinkedField",
                                    "name": "riskFactors",
                                    "plural": true,
                                    "selections": [
                                      (v12/*: any*/),
                                      (v18/*: any*/),
                                      (v19/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "PatientRecommendation",
                                    "kind": "LinkedField",
                                    "name": "recommendations",
                                    "plural": true,
                                    "selections": [
                                      (v12/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "rank",
                                        "storageKey": null
                                      },
                                      (v19/*: any*/),
                                      (v10/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "accepted",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "admissionTime",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "admissionType",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "admittingComplaint",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "anticipatedDischargeTime",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "AuditUser",
                            "kind": "LinkedField",
                            "name": "anticipatedDischargeUpdatedBy",
                            "plural": false,
                            "selections": (v23/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PersonnelRole",
                            "kind": "LinkedField",
                            "name": "attendingPhysician",
                            "plural": false,
                            "selections": [
                              (v21/*: any*/),
                              (v12/*: any*/),
                              (v22/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v24/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "BedRequest",
                            "kind": "LinkedField",
                            "name": "bedRequests",
                            "plural": true,
                            "selections": [
                              (v12/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "bedRequestType",
                                "storageKey": null
                              },
                              (v24/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "updatedWhen",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "bedExchangeName",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "currentDayOfStay",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "decisionTime",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "dischargeVendor",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "DrgAttributes",
                            "kind": "LinkedField",
                            "name": "drgAttributes",
                            "plural": false,
                            "selections": [
                              (v12/*: any*/),
                              (v10/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "level",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "title",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "AuditUser",
                            "kind": "LinkedField",
                            "name": "drgUpdatedBy",
                            "plural": false,
                            "selections": [
                              (v12/*: any*/),
                              (v21/*: any*/),
                              (v22/*: any*/),
                              (v20/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "homeBedExchangeName",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "InsurancePlan",
                            "kind": "LinkedField",
                            "name": "insurancePlans",
                            "plural": true,
                            "selections": [
                              (v12/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "planName",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "priority",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "VisitMeta",
                            "kind": "LinkedField",
                            "name": "meta",
                            "plural": false,
                            "selections": [
                              (v12/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "decisionDue",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "dischargeToday",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "plannedDischargeExceeded",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "timeElapsedSinceAdmission",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "tlosExceeded",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Patient",
                            "kind": "LinkedField",
                            "name": "patient",
                            "plural": false,
                            "selections": [
                              (v12/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "age",
                                "storageKey": null
                              },
                              (v21/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "gender",
                                "storageKey": null
                              },
                              (v22/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "middleInitial",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "mrn",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "patientProblem",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "targetDischargeTime",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "tlos",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "visitNumber",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "visitStatus",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "WorkingDischargeDispositionDTO",
                            "kind": "LinkedField",
                            "name": "workingDischargeDisposition",
                            "plural": false,
                            "selections": [
                              (v10/*: any*/),
                              (v12/*: any*/),
                              (v25/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Plan",
                            "kind": "LinkedField",
                            "name": "plan",
                            "plural": false,
                            "selections": [
                              (v12/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Barrier",
                                "kind": "LinkedField",
                                "name": "barriers",
                                "plural": true,
                                "selections": [
                                  (v12/*: any*/),
                                  (v15/*: any*/),
                                  (v19/*: any*/),
                                  (v26/*: any*/),
                                  (v27/*: any*/),
                                  (v17/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "BarrierCategory",
                                    "kind": "LinkedField",
                                    "name": "category",
                                    "plural": false,
                                    "selections": [
                                      (v12/*: any*/),
                                      (v10/*: any*/),
                                      (v25/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "BarrierSourceType",
                                        "kind": "LinkedField",
                                        "name": "sourceTypes",
                                        "plural": true,
                                        "selections": [
                                          (v12/*: any*/),
                                          (v10/*: any*/),
                                          (v25/*: any*/),
                                          (v11/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "activeDirectorySourceName",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "hasConfiguredList",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "BarrierSourceDetail",
                                            "kind": "LinkedField",
                                            "name": "sourceDetails",
                                            "plural": true,
                                            "selections": [
                                              (v12/*: any*/),
                                              (v10/*: any*/),
                                              (v25/*: any*/),
                                              (v11/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Escalation",
                                    "kind": "LinkedField",
                                    "name": "escalation",
                                    "plural": false,
                                    "selections": [
                                      (v12/*: any*/),
                                      (v28/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v28/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "ownerMessageStatus",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "ownerMessageStatusDate",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "ownerMessageDeliveryDate",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "owner",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "CodeTablePair",
                                    "kind": "LinkedField",
                                    "name": "ownerRole",
                                    "plural": false,
                                    "selections": (v29/*: any*/),
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "sourceTypeCode",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "sourceName",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "BarrierNote",
                                    "kind": "LinkedField",
                                    "name": "notes",
                                    "plural": true,
                                    "selections": [
                                      (v12/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "text",
                                        "storageKey": null
                                      },
                                      (v27/*: any*/),
                                      (v28/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "condition": "skipOwnerKnownUser",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "KnownUser",
                                        "kind": "LinkedField",
                                        "name": "ownerKnownUser",
                                        "plural": false,
                                        "selections": [
                                          (v12/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "emailReceiver",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "instantMessageReceiver",
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ]
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "CareTeamMember",
                                "kind": "LinkedField",
                                "name": "careTeamMembers",
                                "plural": true,
                                "selections": [
                                  (v12/*: any*/),
                                  (v15/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "CodeTablePair",
                                    "kind": "LinkedField",
                                    "name": "role",
                                    "plural": false,
                                    "selections": (v29/*: any*/),
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "primary",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "PlanMeta",
                                "kind": "LinkedField",
                                "name": "meta",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "MilestoneMeta",
                                    "kind": "LinkedField",
                                    "name": "milestoneMeta",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "overdue",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "onTime",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "completed",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "LengthOfStayMeta",
                                    "kind": "LinkedField",
                                    "name": "lengthOfStayMeta",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "forecast",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "cappedForecast",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "actualOE",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Milestone",
                                "kind": "LinkedField",
                                "name": "milestones",
                                "plural": true,
                                "selections": [
                                  (v12/*: any*/),
                                  (v15/*: any*/),
                                  (v19/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "dueDate",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "dueDateCutoff",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "completedDate",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "track",
                                    "storageKey": null
                                  },
                                  (v17/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "duplicate",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "progressionIndicator",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "toBeAdmitted",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "anticipatedTransferTime",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "anticipatedDischargeTimeAutoPopulated",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "anticipatedTransferTimeAutoPopulated",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cursor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Bed",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                      },
                      (v12/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v13/*: any*/),
            "filters": [
              "type",
              "query"
            ],
            "handle": "connection",
            "key": "EscalationListPaginationContainer_beds",
            "kind": "LinkedHandle",
            "name": "beds"
          }
        ],
        "storageKey": null
      },
      {
        "condition": "getSettingsRoles",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserSetting",
            "kind": "LinkedField",
            "name": "userSetting",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "FavoriteBarrier",
                "kind": "LinkedField",
                "name": "barriers",
                "plural": true,
                "selections": [
                  (v12/*: any*/),
                  (v15/*: any*/),
                  (v19/*: any*/),
                  (v11/*: any*/),
                  (v26/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CodeTablePair",
                    "kind": "LinkedField",
                    "name": "category",
                    "plural": false,
                    "selections": [
                      (v10/*: any*/),
                      (v25/*: any*/),
                      (v12/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "templateId",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": "barrierEscalationRoles",
            "args": [
              {
                "kind": "Literal",
                "name": "codeTableType",
                "value": "BarrierEscalationRole"
              }
            ],
            "concreteType": "CodeTable",
            "kind": "LinkedField",
            "name": "codeTables",
            "plural": true,
            "selections": [
              (v10/*: any*/),
              (v25/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ordinal",
                "storageKey": null
              },
              (v11/*: any*/),
              (v12/*: any*/)
            ],
            "storageKey": "codeTables(codeTableType:\"BarrierEscalationRole\")"
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "e0a499873aa5e3a14f794005d46c439a",
    "id": null,
    "metadata": {},
    "name": "EscalationListQuery",
    "operationKind": "query",
    "text": "query EscalationListQuery(\n  $first: Int\n  $after: String\n  $getSettingsRoles: Boolean!\n  $skipOwnerKnownUser: Boolean!\n  $type: SearchType\n  $query: String\n) {\n  ...EscalationListPaginationContainer_search_27bWcs\n}\n\nfragment EscalationListPaginationContainer_search_27bWcs on Query {\n  userSetting @include(if: $getSettingsRoles) {\n    barriers {\n      id\n      name\n      description\n      active\n      dischargeDelay\n      category {\n        code\n        value\n        id\n      }\n      templateId\n    }\n  }\n  barrierEscalationRoles: codeTables(codeTableType: BarrierEscalationRole) @include(if: $getSettingsRoles) {\n    code\n    value\n    ordinal\n    active\n    id\n  }\n  deliveryMethods: codeTables(codeTableType: DeliveryMethod) {\n    code\n    active\n    id\n  }\n  viewer {\n    beds(first: $first, after: $after, type: $type, query: $query) {\n      totalCount\n      pageInfo {\n        endCursor\n        hasNextPage\n        hasPreviousPage\n        startCursor\n        totalCount\n      }\n      edges {\n        bed: node {\n          id\n          name\n          exchangeName\n          status\n          department {\n            id\n            exchangeName\n            name\n            type\n          }\n          visit {\n            id\n            vector {\n              id\n              patientId\n              encounterId\n              predictionDate\n              conditions {\n                name\n                riskBracket\n                riskFactors {\n                  id\n                  type\n                  description\n                }\n                recommendations {\n                  id\n                  rank\n                  description\n                  code\n                  accepted\n                }\n              }\n            }\n            admissionTime\n            admissionType\n            admittingComplaint\n            anticipatedDischargeTime\n            anticipatedDischargeUpdatedBy {\n              id\n              userName\n              firstName\n              lastName\n            }\n            attendingPhysician {\n              firstName\n              id\n              lastName\n            }\n            bedRequestStatus\n            bedRequests {\n              id\n              bedRequestType\n              bedRequestStatus\n              updatedWhen\n              bedExchangeName\n            }\n            currentDayOfStay\n            decisionTime\n            dischargeVendor\n            drgAttributes {\n              id\n              code\n              level\n              title\n            }\n            drgUpdatedBy {\n              id\n              firstName\n              lastName\n              userName\n            }\n            homeBedExchangeName\n            insurancePlans {\n              id\n              planName\n              priority\n            }\n            meta {\n              id\n              decisionDue\n              dischargeToday\n              plannedDischargeExceeded\n              timeElapsedSinceAdmission\n              tlosExceeded\n            }\n            patient {\n              id\n              age\n              firstName\n              gender\n              lastName\n              middleInitial\n              mrn\n            }\n            patientProblem\n            targetDischargeTime\n            tlos\n            visitNumber\n            visitStatus\n            workingDischargeDisposition {\n              code\n              id\n              value\n            }\n            plan {\n              id\n              barriers {\n                id\n                name\n                description\n                dischargeDelay\n                pinned\n                status\n                category {\n                  id\n                  code\n                  value\n                  sourceTypes {\n                    id\n                    code\n                    value\n                    active\n                    activeDirectorySourceName\n                    hasConfiguredList\n                    sourceDetails {\n                      id\n                      code\n                      value\n                      active\n                    }\n                  }\n                }\n                escalation {\n                  id\n                  auditMeta {\n                    createdBy {\n                      id\n                      userName\n                      firstName\n                      lastName\n                    }\n                    updatedBy {\n                      id\n                      userName\n                      firstName\n                      lastName\n                    }\n                    created\n                    updated\n                  }\n                }\n                auditMeta {\n                  createdBy {\n                    id\n                    userName\n                    firstName\n                    lastName\n                  }\n                  updatedBy {\n                    id\n                    userName\n                    firstName\n                    lastName\n                  }\n                  created\n                  updated\n                }\n                ownerMessageStatus\n                ownerMessageStatusDate\n                ownerMessageDeliveryDate\n                ownerKnownUser @skip(if: $skipOwnerKnownUser) {\n                  id\n                  emailReceiver\n                  instantMessageReceiver\n                }\n                owner\n                ownerRole {\n                  id\n                  code\n                  value\n                }\n                sourceTypeCode\n                sourceName\n                notes {\n                  id\n                  text\n                  pinned\n                  auditMeta {\n                    createdBy {\n                      id\n                      userName\n                      firstName\n                      lastName\n                    }\n                    updatedBy {\n                      id\n                      userName\n                      firstName\n                      lastName\n                    }\n                    created\n                    updated\n                  }\n                }\n              }\n              careTeamMembers {\n                id\n                name\n                role {\n                  id\n                  code\n                  value\n                }\n                primary\n              }\n              meta {\n                milestoneMeta {\n                  overdue\n                  onTime\n                  completed\n                }\n                lengthOfStayMeta {\n                  forecast\n                  cappedForecast\n                }\n                actualOE\n              }\n              milestones {\n                id\n                name\n                description\n                dueDate\n                dueDateCutoff\n                completedDate\n                track\n                status\n                duplicate\n              }\n              progressionIndicator\n              toBeAdmitted\n            }\n            anticipatedTransferTime\n            anticipatedDischargeTimeAutoPopulated\n            anticipatedTransferTimeAutoPopulated\n          }\n        }\n        cursor\n        node {\n          __typename\n          id\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '1d9ef7c43645c762638208474d1d1efd';

module.exports = node;
